import { Dialog } from "@material-ui/core"

export const PreviewFile = ({ path, open, onClose }) => {
  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      onClose={onClose}
      fullWidth="true"
      maxWidth="md"
      open={open}
    >
      <embed
        src={`${window.location.origin}${path}`}
        type="application/pdf"
        width="1000px"
        height="600px"
      />
    </Dialog>
  )
}
export default PreviewFile
